class Cache {
  constructor () {
    this.store = new Map()
  }

  set (key, value) {
    this.store.set(key, value)
  }

  has (key) {
    return this.store.has(key)
  }

  get (key) {
    return this.store.get(key)
  }
}

const cache = new Cache()

export default cache



// WEBPACK FOOTER //
// ./src/library/cache.js